export default __webpack_public_path__ + "static/media/video1.ae545fa0.mp4";